import { render, staticRenderFns } from "./ProductLook.vue?vue&type=template&id=33f3b590&scoped=true&"
import script from "./ProductLook.vue?vue&type=script&lang=js&"
export * from "./ProductLook.vue?vue&type=script&lang=js&"
import style0 from "./ProductLook.vue?vue&type=style&index=0&id=33f3b590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3b590",
  null
  
)

export default component.exports